const DITypes = {
  JsonRpcDispatcher: Symbol('AllocateJsonRpcDispatcher'),
  DispatcherFactory: Symbol('AllocateDispatcherFactory'),
  AdapterFactory: Symbol('AllocateAdapterFactory'),
};

export default DITypes;
